import { CSSTransition } from 'react-transition-group';
import styles from './ImageInput.module.css';
import React from 'react';
export default function Dropdown(_a) {
    var dropdownVisible = _a.dropdownVisible, hideDropdown = _a.hideDropdown, handleEdit = _a.handleEdit, handleReplace = _a.handleReplace, handleDelete = _a.handleDelete, _b = _a.additionalActions, additionalActions = _b === void 0 ? [] : _b;
    /** Свернуть Dropdown при условии что фокус сместился на компонент извне */
    var handleBlur = function (event) {
        if (event.relatedTarget &&
            event.relatedTarget.classList.contains(styles.menuButton)) {
            return;
        }
        else {
            hideDropdown();
        }
    };
    return (React.createElement(CSSTransition, { in: dropdownVisible, timeout: 200, unmountOnExit: true, classNames: {
            enter: styles.dropdownEnter,
            enterActive: styles.dropdownEnterActive,
            exit: styles.dropdownExit,
            exitActive: styles.dropdownExitActive
        } },
        React.createElement("div", { className: styles.dropdown, tabIndex: -1, onBlur: handleBlur, ref: function (node) { return node === null || node === void 0 ? void 0 : node.focus(); } },
            React.createElement(MenuButton, { title: '\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C', action: handleEdit }),
            React.createElement(MenuButton, { title: '\u0417\u0430\u043C\u0435\u043D\u0438\u0442\u044C', action: handleReplace }),
            React.createElement(MenuButton, { title: '\u0423\u0434\u0430\u043B\u0438\u0442\u044C', action: handleDelete }),
            additionalActions.map(function (_a) {
                var title = _a.title, action = _a.action;
                return (React.createElement(MenuButton, { key: title, title: title, action: action }));
            }))));
}
function MenuButton(_a) {
    var title = _a.title, action = _a.action;
    return (React.createElement("button", { type: 'button', className: styles.menuButton, onClick: action }, title));
}
